export default "__VITE_ASSET__ca8e03f2__"